
import { JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponse } from '@/openapi/order';
import { Component, Prop, Vue } from 'vue-property-decorator';
import Icon from '@/layouts/Icon.vue';
import EnvRepository from '@/repository/EnvRepository';

@Component({
  components: {
    Icon,
  },
})
export default class Ordc01CompleteComponent extends Vue {
  @Prop({ type: Object, required: true })
  confirmPayPostResponse!: JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponse;

  get getOrderConfirmContentsTitle(): string {
    if (!this.confirmPayPostResponse.orderConfirmContents) return '';

    return this.confirmPayPostResponse.orderConfirmContents.title ?? '';
  }

  get getOrderConfirmContentsDesc(): string {
    if (!this.confirmPayPostResponse.orderConfirmContents) return '';

    return this.confirmPayPostResponse.orderConfirmContents.contents ?? '';
  }

  get getTopUrl(): string {
    return EnvRepository.getEnv().VUE_APP_BENEFIT_BENEFITSTATION_URL;
  }
}
